import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    // Unauthenticated user hitting a protected route. If they came in via
    // an invitation link (/accept-invite?token=...), send them to signup
    // carrying the token so the flow survives account creation; otherwise
    // send them to the home page to log in.
    if (location.pathname === '/accept-invite') {
      const inviteToken = new URLSearchParams(location.search).get('token');
      const qs = inviteToken ? `?invite_token=${encodeURIComponent(inviteToken)}` : '';
      return <Navigate to={`/signup${qs}`} />;
    }
    return <Navigate to="/" />;
  }

  const hasFamily = localStorage.getItem('hasFamily') === 'true';
  const invitationAccepted = localStorage.getItem('invitationAccepted') === 'true';
  let pendingInvitations = [];
  try {
    pendingInvitations = JSON.parse(localStorage.getItem('pendingFamilyInvitations') || '[]');
  } catch { /* ignore */ }

  // Allow access to /family and /accept-invite even without a family.
  // A user who just accepted an invitation (status 'accepted', not yet
  // confirmed by admin) is allowed to reach the dashboard.
  const allowedWithoutFamily = ['/family', '/accept-invite', '/dashboard'];

  if (!hasFamily && !allowedWithoutFamily.includes(location.pathname)) {
    if (pendingInvitations.length > 0) {
      return <Navigate to={`/accept-invite?token=${pendingInvitations[0].token}`} />;
    }
    return <Navigate to="/family" />;
  }

  if (!hasFamily && location.pathname === '/dashboard' && !invitationAccepted) {
    if (pendingInvitations.length > 0) {
      return <Navigate to={`/accept-invite?token=${pendingInvitations[0].token}`} />;
    }
    return <Navigate to="/family" />;
  }

  return children;
};

export default ProtectedRoute;